var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DepartmentTree from "~/components/system-manage/department-tree.vue";
import { Prop, Emit } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { UserService } from "~/services/management-service/user.service";
import { namespace, Getter } from "vuex-class";
var AllotModule = namespace("case-allot");
var ChooseDistribution = /** @class */ (function (_super) {
    __extends(ChooseDistribution, _super);
    function ChooseDistribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = [];
        _this.userDataSet = [];
        _this.nowNode = null;
        _this.distributionData = {};
        _this.submitLoading = false;
        _this.collectionType = "";
        _this.item = {};
        _this.currentDept = '';
        _this.departmentData = null;
        return _this;
    }
    ChooseDistribution.prototype.emitRefreshList = function () { };
    ChooseDistribution.prototype.emitClose = function () {
        this.userDataSet = [];
        this.nowNode = null;
        this.currentDept = '';
        this.departmentData = null;
    };
    ChooseDistribution.prototype.getchooseData = function (val, dept) { };
    ChooseDistribution.prototype.getDeptIds = function (val) { };
    Object.defineProperty(ChooseDistribution.prototype, "display", {
        get: function () {
            return this.allotType === "DEPARTMENT" ? "" : this.selectionList;
        },
        set: function (v) {
            this.selectionList = v;
        },
        enumerable: false,
        configurable: true
    });
    // private get currentDept() {
    //   return this.distributeModel.deptIds[0];
    // }
    // private set currentDept(val) {
    //   this.updateDeptIds(val.id);
    //   this.refreshData(val.deptCode);
    // }
    ChooseDistribution.prototype.getDepartmentData = function () {
        if (this.distributeType === "TEL") {
            this.departmentData = this.callDepartmentData;
        }
        else if (this.distributeType === "VISIT") {
            this.departmentData = this.visitDepartmentData;
        }
        else if (this.distributeType === "LEGAL") {
            this.departmentData = this.legalDepartmentData;
        }
    };
    /**
     * 获取当前树选择项
     */
    ChooseDistribution.prototype.getCheckedNodes = function (item) {
        this.item = item;
        if (this.nowNode && item.deptCode === this.nowNode.deptCode) {
            return;
        }
        this.currentDept = item;
        this.updateDeptIds(item.id);
        this.refreshData(item.deptCode);
    };
    //按机构分配
    ChooseDistribution.prototype.submit = function () {
        if (this.distributeModel.deptIds.length === 0) {
            this.$message.error("请选择部门");
            return;
        }
        console.log(this.item, 'item');
        this.getDeptIds(this.item);
    };
    ChooseDistribution.prototype.refreshData = function (code) {
        var _this = this;
        var model = {
            deptCode: code,
            caseSwitch: ""
        };
        this.userService
            .getAllUsers(model, this.pageService)
            .subscribe(function (data) { return (_this.userDataSet = data); });
    };
    ChooseDistribution.prototype.next = function () {
        this.getchooseData(this.selectionList, this.item);
        this.close();
    };
    ChooseDistribution.prototype.onPageChange = function () {
        this.refreshData(this.item.deptCode);
    };
    ChooseDistribution.prototype.success = function () {
        this.$message.success("分配成功");
        this.close();
    };
    ChooseDistribution.prototype.close = function () {
        this.emitRefreshList();
        this.emitClose();
    };
    __decorate([
        Dependencies(PageService)
    ], ChooseDistribution.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], ChooseDistribution.prototype, "userService", void 0);
    __decorate([
        Getter
    ], ChooseDistribution.prototype, "visitDepartmentData", void 0);
    __decorate([
        Getter
    ], ChooseDistribution.prototype, "callDepartmentData", void 0);
    __decorate([
        Getter
    ], ChooseDistribution.prototype, "legalDepartmentData", void 0);
    __decorate([
        AllotModule.State
    ], ChooseDistribution.prototype, "category", void 0);
    __decorate([
        AllotModule.Mutation
    ], ChooseDistribution.prototype, "updateCategory", void 0);
    __decorate([
        AllotModule.Mutation
    ], ChooseDistribution.prototype, "updateDeptIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], ChooseDistribution.prototype, "updateUserIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], ChooseDistribution.prototype, "updateCaseIds", void 0);
    __decorate([
        AllotModule.Getter
    ], ChooseDistribution.prototype, "distributeModel", void 0);
    __decorate([
        Prop({ type: String })
    ], ChooseDistribution.prototype, "distributeType", void 0);
    __decorate([
        Prop({ type: String })
    ], ChooseDistribution.prototype, "allotType", void 0);
    __decorate([
        Emit("refreshList")
    ], ChooseDistribution.prototype, "emitRefreshList", null);
    __decorate([
        Emit("close")
    ], ChooseDistribution.prototype, "emitClose", null);
    __decorate([
        Emit("success")
    ], ChooseDistribution.prototype, "getchooseData", null);
    __decorate([
        Emit("successDept")
    ], ChooseDistribution.prototype, "getDeptIds", null);
    ChooseDistribution = __decorate([
        Component({
            components: {
                DepartmentTree: DepartmentTree
            }
        })
    ], ChooseDistribution);
    return ChooseDistribution;
}(Vue));
export default ChooseDistribution;
